    export enum TicketReportStatus
    {
        Pending = 0,
        SendingToOwner = 1,
        ResolvedInternally = 2
    }
